import createActionTypes from './createActionTypes'

export const namespace = 'PROPERTY'

export const types = createActionTypes(namespace, [
  'CTA_CLICK',
  'RESET',
  'TOGGLE_PROFILING_CONSENT',
  'SET_PROFILING_CONSENT',
])

export const ctaClick = () => ({
  type: types.CTA_CLICK,
})

export const resetProperty = resetState => ({
  type: types.RESET,
  payload: { resetState },
})

export const toggleProfilingConsent = profilingConsent => ({
  type: types.TOGGLE_PROFILING_CONSENT,
  payload: { profilingConsent },
})
export const setProfilingConsent = profilingConsent => ({
  type: types.SET_PROFILING_CONSENT,
  payload: { profilingConsent },
})
